import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { CompatRouter } from 'react-router-dom-v5-compat'

import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

import './styles/index.css'

import App from './App'
import reducers from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)))

window.store = store

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <CompatRouter>
        <App />
      </CompatRouter>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)
